import { JobOffersOverviewData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";
import IconArrowRight from "../icons/IconArrowRight";
import {
  resolveImageUrl,
  resolveLink,
  resolveSectionClasses,
} from "@/storyblok/resolvers";
import Link from "next/link";

export default function JobOffersOverview({
  data,
}: {
  data: JobOffersOverviewData;
}) {
  return (
    <section
      className="section--vacancies-grid"
      style={{
        "--color-background": data.background_color?.color,
      }}
      id={data.anchor}
      {...makeEditable(data)}
    >
      <div className={resolveSectionClasses(data, "container")}>
        <div className="col">
          <h3>{data.title}</h3>
          <div
            dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
          ></div>
        </div>
        <div className="col vacancies-grid">
          {data.items.map((i) => (
            <Link
              href={resolveLink(i.link)}
              className="single_vacancy"
              key={i._uid}
              {...makeEditable(i)}
            >
              <div className="vacancy_content_wrapper">
                <div className="vacancy_visuals">
                  <img
                    className="avatar"
                    src={resolveImageUrl(i.avatar, { width: 70 })}
                    alt={i.avatar.alt}
                  />
                  <img
                    className="vacancy_company_logo"
                    src={resolveImageUrl(i.logo, { width: 100 })}
                    alt={i.logo.alt}
                  />
                </div>
                <div className="vacancy_info">
                  <h3>{i.title}</h3>
                  <p>{i.excerpt}</p>
                </div>
              </div>
              <div className="vacancy_footer">
                <p>{data.open_label}</p>
                <IconArrowRight />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
